import { HttpService } from "../../modules/shared/services/http.service";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export interface CheckPromotionalEligibilityDto {
  jobId: string;
  userId: string;
}

export interface PromotionalEligibilityResponse {
  isEligible: boolean;
  remainingQuota: number | null;
  totalQuota: number | null;
  message: string | null;
}

/**
 * Check if a user is eligible for a promotional quote on a specific job
 */
export const checkPromotionalEligibility = async (
  jobId: string,
  userId: string
): Promise<PromotionalEligibilityResponse> => {
  const response = await HttpService.post(
    "api/v1/quotes/check-promotional",
    { jobId, userId },
    headers,
    true
  );
  return response;
};

